import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { StatsService } from 'src/app/shared/services/stats.service';
import { StatsUpdateLogActions } from './stats-update-log.actions';

@Injectable()
export class StatsUpdateLogEffects {
    private readonly actions$ = inject(Actions);
    private readonly statsService = inject(StatsService);

    save: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(StatsUpdateLogActions.load),
        mergeMap(action => from(this.statsService.updateLog(action.query))
        .pipe(
            map(result => StatsUpdateLogActions.received({
                result
            })),
            catchError((error) => [
                StatsUpdateLogActions.error({
                    error
                }),
            ])
        )))
    );
}
